import { FC, ReactNode } from 'react';

import { BetaBadge, HeaderWrapper } from './Header.styled';

export interface ChatHeaderProps {
  title?: string;
  branding?: ReactNode;
  showBetaBadge?: boolean;
}

export const ChatHeader: FC<ChatHeaderProps> = ({
  title = 'AI Assistant',
  branding,
  showBetaBadge = true,
}) => {
  return (
    <HeaderWrapper>
      <h4>{title}</h4>
      {showBetaBadge && <BetaBadge>Beta</BetaBadge>}
      <div className="action-buttons"></div>
      <div className="branding">{branding}</div>
    </HeaderWrapper>
  );
};
